import { Button } from '@zenterprise-inc/ui';
import Image from 'next/image';

interface Props {
  displayName: string;
  businessTypeName: string;
  isCompleted: boolean;
  onEditClick?: () => void;
}

export const BusinessList = ({ businessTypeName, displayName, isCompleted, onEditClick }: Props) => {
  return (
    <div className={'flex w-full items-center'}>
      <div className={'flex shrink-0 items-center pr-[14px]'}>
        <Image src={'/images/illus-icons/fill-mi-building-rg.svg'} alt={'사업체'} width={32} height={32} />
      </div>
      <div className={'flex-1 py-4'}>
        {isCompleted && <p className={'body-13 mb-1 text-green-600'}>답변 완료했어요!</p>}
        <p className={'w-full'}>
          <span className={'headline-16 align-middle text-gray-800'}>{displayName}</span>
        </p>
        <p className={'body-14 mt-0.5 text-gray-700'}>업종: {businessTypeName}</p>
      </div>
      {isCompleted && (
        <Button.Box type={'button'} className={'ml-5 shrink-0'} onClick={onEditClick}>
          수정
        </Button.Box>
      )}
    </div>
  );
};
